<template>
  <v-dialog
    v-model="show"
    :persistent="persistent"
    max-width="300px"
  >
    <v-card>
      <v-card-title
        class="text-body-1"
        v-html="message"
      >
        <!-- {{ message }} -->
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="debounceBtnClick(false)"
        >
          <template v-if="falseLabel">
            {{ falseLabel }}
          </template>
          <template v-else>
            {{ $t('Text.False') }}
          </template>
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="debounceBtnClick(true)"
        >
          <template v-if="trueLabel">
            {{ trueLabel }}
          </template>
          <template v-else>
            {{ $t('Text.True') }}
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    message: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: true
    },
    trueLabel: {
      type: String,
      default: null
    },
    falseLabel: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      show: this.value
    }
  },
  watch: {
    value: function (val) {
      this.show = val
    },
    show: function (val) {
      this.$emit('input', val)
    }
  },
  created () {
    this.debounceBtnClick = _.debounce(this.btnClick, 1000, { leading: true, trailing: false })
  },
  methods: {
    btnClick: function (isConfirm) {
      if (isConfirm) {
        this.$emit('confirm')
      } else {
        this.$emit('cancel')
      }
      this.show = false
    }
  }
}
</script>
